import styles from '../../pages/chat/Chat.module.css';
import { LoadingAnimation } from '../../assets/loading';

const Loading = () => {
  return (
    <div className={styles.loadingOverlay}>
      <div className={styles.loadingIcon}>
        {LoadingAnimation}
      </div>
    </div>
  );
};

export default Loading;